import type { RouteRef } from '@backstage/core-plugin-api';
import type { IconElement } from '@backstage/frontend-plugin-api';

import { createRouteRef } from '@backstage/core-plugin-api';
import {
  createFrontendPlugin,
  PageBlueprint } from '@backstage/frontend-plugin-api';
import { Icon } from '@iconify/react';
import { createElement } from 'react';

const placeholderPage = (
  name: string,
  path: string,
  title: string,
  icon: IconElement,
  routeRef: RouteRef,
) =>
  PageBlueprint.make({
    name,
    params: {
      icon,
      loader: async () => createElement('div'),
      path,
      routeRef,
      title,
    },
  });

export const navigationPagesPlugin = createFrontendPlugin({
  extensions: [
    placeholderPage(
      'solution-marketplace',
      '/solution-marketplace',
      'Solution Marketplace',
      createElement(Icon, { icon: 'ri:shopping-bag-4-line' }),
      createRouteRef({
        id: 'solution-marketplace',
      }),
    ),
    placeholderPage(
      'ipen-apps',
      '/ipen-apps',
      'iPEN Apps',
      createElement(Icon, { icon: 'ri:shopping-bag-4-line' }),
      createRouteRef({
        id: 'ipen-apps',
      }),
    ),
    placeholderPage(
      'report-incident',
      '/report-incident',
      'Report Incident',
      createElement(Icon, { icon: 'ri:alert-line' }),
      createRouteRef({
        id: 'report-incident',
      }),
    ),
  ],
  pluginId: 'ipen-foo',
});
